import React, { Component, Fragment } from "react";
import ReactHtmlParser from 'react-html-parser';

class InfoStranka extends Component {
  render() {
    //console.log("Inf", this.props);
    return (
      <React.Fragment>
        {/* {this.props.zadani.cesta.nadpis !== undefined ? (
          <div className="jumbotron mt-3">
            {true && this.props.zadani.cesta.nadpis}
          </div>
        ) : null}
        <div className="col" style={this.stylePath}>
          {this.textToHtml(this.props.zadani.cesta.popiscesty)}
        </div>
        {this.props.zadani.cesta.img !== undefined ? (
          <div className="container">
            <div className="row">
              <div className="col">
                <img
                  className="mx-auto d-block img-fluid"
                  alt="cesta"
                  src={this.props.zadani.cesta.img}
                />
              </div>
            </div>
          </div>
        ) : null}
        {this.props.zadani.cesta.text !== undefined ? (
          <div className="col" style={this.stylePath}>
            {this.textToHtml(this.props.zadani.cesta.text)}
          </div>
        ) : null} */}
        {this.renderInfo()}

        <div className="row mt-4">
          <div className="col">
            <button className="btn btn-secondary" onClick={this.props.onPrev}>
              Předchozí
            </button>
          </div>
          <div className="col">
            <button
              className="btn btn-primary float-right"
              onClick={this.props.onNext}
            >
              Další
            </button>
          </div>
        </div>
      </React.Fragment>
    );
  }


  renderInfo = () => {
    //console.log("Otazka:", this.props.zadani.otazka);
    let stavba = [];
  
    for (let i=0; i< this.props.zadani.cesta.length; i++)
    {
        let prvek = this.props.zadani.cesta[i];
        //console.log("prvek", prvek);
        if (prvek.nadpis!=="" && prvek.nadpis!==undefined)
        {
            stavba.push(
              <React.Fragment key={i}>
                <div className="jumbotron mt-3">
                  {prvek.nadpis}
                </div>
              </React.Fragment>);
        }

  
        if (prvek.img!=="" && prvek.img!==undefined)
        {
            stavba.push(
              <React.Fragment key={i}>
              <div className="d-flex align-items-center mt-1">
              <img
                className="img-fluid mx-auto"
                alt="otazka"
                src={prvek.img} />
                </div>
              </React.Fragment>);
        }
  
        
        if (prvek.popiscesty!=="" && prvek.popiscesty!==undefined)
        {
            stavba.push(
              <React.Fragment key={i}>
                {this.textToHtml(prvek.popiscesty)}
              </React.Fragment>);
        }
    }
  
    //console.log("Stavba: ",stavba);
    return  (<div className="col mt-2 border-light" style={this.styleQuestion}> {  stavba } </div>);
  }

  textToHtml(html) {

    
    return  (<div> { ReactHtmlParser (html) } </div>);

    let arr = html.split(/<br\s*\/?>/i);
    return arr.reduce(
      (el, line, index) =>
        el.concat(
          <Fragment key={index}>
            {line}
            <br />
          </Fragment>
        ),
      []
    );
  }
}

export default InfoStranka;
